// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ICUXScil [role=row] [role=cell]:first-child{width:20%}.ICUXScil [role=row] [role=cell]:nth-child(2){width:40%}.ICUXScil [role=row] [role=cell]:nth-child(3){width:20%}.ICUXScil [role=row] [role=cell]:last-child{width:20%}.WLPMV1EI{display:flex;gap:2rem}.WLPMV1EI>*{flex:1}`, "",{"version":3,"sources":["webpack://./src/page-components/modals/ImportFromLibrary.module.scss"],"names":[],"mappings":"AAGM,6CACE,SAAA,CAGF,8CACI,SAAA,CAGJ,8CACI,SAAA,CAGJ,4CACE,SAAA,CAMR,UACE,YAAA,CACA,QAAA,CAEA,YACE,MAAA","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"table": `ICUXScil`,
	"intentView": `WLPMV1EI`
};
export default ___CSS_LOADER_EXPORT___;
